import { TABNAME_MAX_LENGTH } from '@/config/name';
import { createNameSchema } from '@/features/dashboard/lib/validateName';

/**
 * Validate dashboard name.
 * Throws error if invalid.
 */
export const validateDashboardName = (name: string): void => {
  const schema = createNameSchema('Dashboard name', 100);
  const result = schema.safeParse(name);

  if (!result.success) {
    throw new Error(result.error.issues[0]?.message || 'Invalid dashboard name');
  }
};

/**
 * Validate tab name.
 * Throws error if invalid or duplicate.
 */
export const validateTabName = (name: string, existingNames: string[]): void => {
  const schema = createNameSchema('Tab name', TABNAME_MAX_LENGTH);
  const result = schema.safeParse(name);

  if (!result.success) {
    throw new Error(result.error.issues[0]?.message || 'Invalid tab name');
  }

  const isDuplicate = existingNames.some(
    existing => existing.trim().toLowerCase() === name.trim().toLowerCase()
  );

  if (isDuplicate) {
    throw new Error('Tab name must be unique');
  }
};

/**
 * Get tab name validation error message.
 */
export const getTabNameError = (name: string, existingNames: string[]): string | undefined => {
  try {
    validateTabName(name, existingNames);
    return undefined;
  } catch (error) {
    return error instanceof Error ? error.message : 'Invalid tab name';
  }
};
